<div class="comment col" (click)="onCommentsClicked(name)" [ngClass]="commentsClass(comments)">
	<div *ngFor="let cmt of comments.comments; let idx = index" class="input-group mb-3">
		<input [type]="canDeleteComment(idx) ? 'search' : 'text'"
			class="form-control" [(ngModel)]="cmt.msg"
			[disabled]="!canComment(comments, idx)"
			[ngClass]="{'text': idx > 0 && idx < comments.comments.length - 1, 'last-text': idx > 0 && idx === comments.comments.length - 1}"
			(focusout)="onCommentFocusOut(idx)"
			(search)="onCommentSearchClear(idx)"
		/>
		<span class="input-group-text comment-stamp" id="basic-addon2">
			<cite>
				{{cmt.name}}<br>{{commentTimeString(cmt.time)}}
			</cite>
		</span>
	</div>
	<div *ngIf="canAddComment()">
		<button class="btn btn-sm btn-outline-secondary" (click)="onAddComment()">+</button>
	</div>
</div>
